import NonAuthLayout from './NonAuthLayout';

export default NonAuthLayout;
